import script from "./ViewMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewMain.vue?vue&type=script&setup=true&lang=ts"

import "./ViewMain.vue?vue&type=style&index=0&id=89b41a32&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b41a32"]])

export default __exports__